// extracted by mini-css-extract-plugin
export default {"productDescription":"A_-z","featuredDescription":"B_-z","description":"C_-z","more":"D_-z","descriptionSku":"E_-z"};